'use client';

import { useEffect, useState } from 'react';

import { useScreenSize } from '@/hooks/useScreenSize';
import { defaultLocale } from '@/lib/i18n/dictionaries';

import { BlockReference } from '@/components/cms/types/block';
import LiveChat from '@/components/organisms/socialWidget/LiveChat';
import SocialWidgetStrapi, {
  SocialWidgetStrapiProps,
} from '@/components/organisms/socialWidget/SocialWidgetStrapi';

import SocialWidgetStrapiDC, {
  SocialWidgetStrapiProps as SocialWidgetStrapiPropsDC,
} from '@/decodo/components/organisms/SocialWidget/SocialWidgetStrapi';
import { apiCallStrapi } from '@/utils/fetch';

type SocialWidgetPayload = BlockReference<SocialWidgetStrapiProps>;

const Socials = () => {
  const { isDesktop } = useScreenSize();

  const shouldShowWidget = defaultLocale === 'zh-cn' && isDesktop;
  const [widgetData, setWidgetData] = useState<SocialWidgetPayload | null>(
    null
  );

  useEffect(() => {
    if (!shouldShowWidget) {
      return;
    }

    apiCallStrapi<SocialWidgetPayload>({
      path: '/social-widget',
      query: {
        pLevel: 'deep',
      },
    })
      .then((r) => {
        setWidgetData(r as SocialWidgetPayload);
      })
      .catch(console.error);
  }, [shouldShowWidget]);

  if (!shouldShowWidget) {
    return <LiveChat />;
  }
  if (!widgetData?.data?.attributes) {
    return null;
  }

  const isDecodo =
    process.env.NEXT_PUBLIC_COMPONENT_VARIANT?.includes('decodo');

  if (isDecodo) {
    return (
      <SocialWidgetStrapiDC
        block={widgetData.data.attributes as SocialWidgetStrapiPropsDC}
      />
    );
  }

  return <SocialWidgetStrapi block={widgetData.data.attributes} />;
};

export default Socials;
